import PropTypes from 'prop-types'
import React from 'react'

import MenuItem from './MenuItem'

const MainMenuLinksList = ({ items, className, onClick, children, style }) => {
  return (
    <ul className={className} onClick={onClick} style={style}>
      {items.map((data, idx) => (
        <MenuItem {...data} key={idx} />
      ))}
      {children}
    </ul>
  )
}

MainMenuLinksList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  style: PropTypes.object,
  children: PropTypes.node
}

export default MainMenuLinksList
